import type { Address } from '~/graphql/types';

const getAddressString = (address: Address) =>
  `${address.street} ${address.houseNumber}${address.addition ?? ''}, ${address.postcode} ${address.city}`;

export default getAddressString;
